<template>
    <a-card id="Adminuser">
        <div :class="advanced ? 'search' : null">
            <a-form layout="inline" class="searchForm">
                <a-form-item label="姓名" :labelCol="{span: 5}" :wrapperCol="{span: 18, offset: 1}">
                    <a-input  :maxLength="30" placeholder="请输入姓名" v-model="name"/>
                </a-form-item>
                <a-form-item label="手机号" :labelCol="{span: 5}" :wrapperCol="{span: 18, offset: 1}">
                    <a-input :maxLength="11" placeholder="请输入手机号" v-model="mobile"/>
                </a-form-item>
                <a-form-item style="margin-right: 35px;">
                    <a-button type="primary" @click="getList(1)">查询</a-button>
                    <a-button style="margin-left: 8px" @click="resetSearch()">重置</a-button>
                </a-form-item>
                <a-form-item v-permission="`Auth.Admin.Add`">
                    <a-button icon="plus" @click="addNew" type="primary">添加用户</a-button>
                </a-form-item>
            </a-form>
        </div>
        <div style="margin-top: 15px;">
            <standard-table
                    :columns="columns"
                    rowKey="id"
                    :loading="loading"
                    :dataSource="dataSource"
                    :pagination="{
                    current: pageIndex,
                    pageSize: pageSize,
                    total: total,
                    showSizeChanger: true,
                    showLessItems: true,
                    showQuickJumper: true,
                    showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
                    onChange: onPageChange,
                    onShowSizeChange: onSizeChange,
                    }"
                >
                <div v-auth="`Auth.Admin.Status`" slot="enabled" slot-scope="{text}">
                    <!--<span v-if="text" style="color:#009688;">启用</span>
                    <span v-if="!text" style="color:#FF5722;">禁用</span>-->
                    <a-switch @change="updateStatus(text)" v-model="text.enabled" checked-children="启用"
                              un-checked-children="禁用"/>
                </div>
                <div slot="gender" slot-scope="{text}">
                    <span v-if="text == 1">男</span>
                    <span v-if="text == 2">女</span>
                </div>
                <div slot="action" slot-scope="{text, record}" v-if="record.id != 0">
                    <a v-permission="`Auth.Admin.Edit`" style="margin-right: 8px" @click="edit(record)">
                        <a-icon type="edit"/>
                        编辑
                    </a>
                    <a v-permission="`Auth.Admin.Role`" @click="setRole(record)" style="margin-right: 8px">
                        <a-icon type="team"/>
                        配置角色
                    </a>
                    <a v-permission="`Auth.Admin.Pass`" @click="resetPass(record)" style="margin-right: 8px;color:#13c2c2;">
                        <a-icon type="lock"/>
                        重置密码
                    </a>
                    <a-popconfirm v-permission="`Auth.Admin.Delete`"
                            title="确定删除？"
                            @confirm="deleteRecord(record)">
                        <a style="margin-right: 8px;color: red;">
                            <a-icon type="delete"/>
                            删除
                        </a>
                    </a-popconfirm>
                </div>
                <div slot="action" v-else>
                    -
                </div>
            </standard-table>
        </div>
        <!-- 编辑添加 -->
        <a-modal v-model="addvisible" :title="addModelTitle" @ok="handleOk" @cancel="handleCancel">
            <a-form-model
                    ref="ruleForm"
                    :model="form"
                    :rules="rules"
                    :label-col="labelCol"
                    :wrapper-col="wrapperCol"
            >
                <a-form-model-item ref="name" label="姓名" prop="name">
                    <a-input @change="e => form.name = e.target.value.replace(/\s*/g, '')"
                             v-model="form.name" placeholder="请输入姓名" @blur=" () => { $refs.name.onFieldBlur() }"/>
                </a-form-model-item>
                <a-form-model-item label="性别" prop="gender">
                    <a-radio-group v-model="form.gender">
                        <a-radio :value="1">男</a-radio>
                        <a-radio :value="2">女</a-radio>
                    </a-radio-group>
                </a-form-model-item>
                <a-form-model-item ref="mobile" label="手机号" prop="mobile">
                    <a-input v-model="form.mobile" placeholder="请输入手机号" @blur=" () => { $refs.mobile.onFieldBlur() }"/>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
        <!-- 重置密码 -->
        <a-modal v-model="resetvisible" title="重置密码" @ok="resetOK" @cancel="handleCancel">
            <a-form-model
                    ref="ruleForm"
                    :model="form"
                    :rules="rules"
                    :label-col="labelCol"
                    :wrapper-col="wrapperCol"
            >
                <a-form-model-item ref="mobile" label="手机号" prop="mobile">
                    <a-input v-model="form.mobile" disabled @blur=" () => { $refs.mobile.onFieldBlur() }"/>
                </a-form-model-item>
                <a-form-model-item ref="password" label="密码" prop="password">
                    <a-input-password placeholder="请输入新密码" v-model="form.password" @blur=" () => { $refs.password.onFieldBlur() }"/>
                </a-form-model-item>

            </a-form-model>
        </a-modal>
        <!-- 配置角色 -->
        <a-drawer
                title="角色配置"
                placement="right"
                width="40%"
                :closable="false"
                :destroyOnClose="true"
                :visible="rolevisible"
                @close="close"
        >
            <a-spin :spinning="spinning" class="rolesBox">
                <a-form layout="inline" :form="form" :label-col="{ span: 15 }" :wrapper-col="{ span: 4 }">
                    <a-form-item style="width:33%;margin-right:0;" :label="item.name"
                                 v-for="item in roleData"
                                 :key="item.id">
                        <a-switch v-model="item.hasRole" />
                    </a-form-item>
                </a-form>
                <div class="btns">
                    <a-button type="primary" @click="submitRole()">保存</a-button>
                    <a-button style="margin-left: 8px" @click="resetRole()">重置</a-button>
                </div>
            </a-spin>
        </a-drawer>
    </a-card>
</template>

<script>
    import StandardTable from "@/components/table/StandardTable";

    const columns = [
        {
            title: "姓名",
            dataIndex: "name",
            align:'center'
        },
        {
            title: "性别",
            dataIndex: "gender",
            align:'center',
            scopedSlots: {customRender: "gender"}
        },
        // {
        //     title: "所属机构",
        //     dataIndex: "organizationName"
        // },
        {
            title: "手机",
            align:'center',
            dataIndex: "mobile"
        },
        {
            title: "状态",
            align:'center',
            scopedSlots: {customRender: "enabled"}
        },
        {
            title: "创建时间",
            align:'center',
            dataIndex: "createTime"
        },
        {
            title: "操作",
            align:'center',
            scopedSlots: {customRender: "action"}
        }
    ];
    const rolecolumns = [
        {
            title: "应用名称",
            dataIndex: "name",
            width: 200,
            align: "center"
        },
        {
            title: "权限",
            scopedSlots: {customRender: "action"},
            align: "center"
        }
    ]

    export default {
        name: "Adminuser",
        components: {StandardTable},
        data() {
            const checkAccount = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('请输入账号'))
                } else {
                    if (!/^[0-9a-zA-Z]{6,16}$/.test(value)) {
                        callback(new Error('请输入6-16位字符，可包含字母、数字、下划线!'))
                    } else {
                        callback()
                    }
                }
            }
            const checkPass = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('请输入密码'))
                } else {
                    if (!/^[0-9a-zA-Z]{6,18}$/.test(value)) {
                        callback(new Error('请输入6到18位密码'))
                    } else {
                        callback()
                    }
                }
            }
            const checkMobile = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('请输入手机号'))
                } else {
                    if (!/^1[3456789]\d{9}$/.test(value)) {
                        callback(new Error('请输入正确的手机号'))
                    } else {
                        callback()
                    }
                }
            }
            return {
                advanced: false,
                columns: columns,
                loading: true,
                dataSource: [],
                selectedRows: [],
                checkedList: [],
                istoggleAdvanced: false, //是否显示展开按钮
                pageIndex: 1,
                pageSize: 10,
                total: 0,
                addvisible: false,
                resetvisible: false,
                spinning: false,
                addoredit: 'add',
                enabledText: '',
                editId: '',
                labelCol: {span: 6},
                wrapperCol: {span: 14},
                other: "",
                name: '',
                mobile: '',
                addModelTitle: "添加用户",
                organizationList: [],
                form: {
                    name: "",
                    gender: 1,
                    mobile: "",
                    password: "",
                    // organizationId: undefined,
                    enabled: true
                },
                rules: {
                    name: [
                        {required: true, message: '请输入姓名', trigger: 'blur'},
                        {min: 2, max: 20, message: '姓名长度为 2 到 20 个字符', trigger: 'blur'},
                    ],
                    account: [
                        {required: true, validator: checkAccount, trigger: 'blur'}
                    ],
                    mobile: [
                        {required: true, validator: checkMobile, trigger: 'blur'}
                    ],
                    password: [
                        {required: true, validator: checkPass, trigger: 'blur'}
                    ],
                    gender: [
                        {required: true, message: "请选择性别", trigger: "change"}
                    ],

                },
                showPass: false,
                rolevisible: false,
                roleData: [],
                rolecolumns: rolecolumns,
                roleChecked: '',
                userId: '',
                organizationId: "",
            };
        },
        // authorize: {
        //   deleteRecord: "delete"
        // },
        watch: {
            "form.password"(newValue, oldValue) {
                if (this.form.password.indexOf('*') >= 0) {
                    this.showPass = false
                } else {
                    this.showPass = true
                }
            },
        },
        created() {
            this.getList();
            this.$http.loadAllByType({isOnlySuperior: false}).then(res => {
                    this.organizationList = res.data.data
            });
        },
        methods: {
            getList(pageIndex) {
                if(pageIndex){
                  this.pageIndex = pageIndex  
                }
                let params = {
                    PageIndex: this.pageIndex,
                    PageSize: this.pageSize,
                    name: this.name,
                    mobile: this.mobile
                };
                this.$http.adminList(params)
                .then(res => {
                    this.loading = false
                        this.dataSource = res.data.data.items
                        this.total = res.data.data.totalCount
                })
                .catch(err => {
                    this.loading = false
                })
            },

            resetSearch() {
                this.name = ''
                this.mobile = ''
                this.getList()
            },
            toggleAdvanced() {
                this.advanced = !this.advanced;
            },
            addNew() {
                this.addModelTitle = "添加用户";
                this.addvisible = true;
                this.addoredit = 'add'
                this.resetForm()
            },
            edit(record) {
                this.addModelTitle = "编辑用户";
                this.addvisible = true;
                this.addoredit = 'edit'
                this.form.name = record.name
                // this.form.organizationId = record.organizationId;
                this.form.enabled = record.enabled
                this.editId = record.id
                this.form.gender = record.gender
                this.form.mobile = record.mobile

            },
            handleOk() {
                this.$message.destroy();
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        if (this.addoredit == 'add') {
                            this.addData(this.form)
                        } else {
                            this.editData(this.form)
                        }
                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                });
            },
            // 新增请求接口
            addData(params) {
                this.$http.addAdmin(params)
                    .then(res => {
                            this.addvisible = false
                            this.getList();
                            this.$message.success('添加成功');
                            this.resetForm()
                       
                    });
            },
            // 修改请求接口
            editData(params) {
                params.id = this.editId

                this.$http.editAdmin(params)
                    .then(res => {
                            this.addvisible = false
                            this.getList();
                            this.$message.success('修改成功');
                            this.resetForm()
                     
                    });
            },
            handleVisibleChange(record) {
                if (record.enabled) {
                    this.enabledText = '禁用'
                } else {
                    this.enabledText = '启用'
                }
            },
            // 修改状态
            updateStatus(record) {
                let formData = new FormData()
                formData.append('id',record.id)
                formData.append('enabled',record.enabled)
                this.$http.updateStatusAdmin(formData)
                    .then(res => {
                        this.$message.destroy()
                            this.getList();
                            this.$message.success('修改成功');
                      
                    });
            },
            // 重置密码
            resetPass(record) {
                this.resetvisible = true
                this.form.account = record.account
                this.form.mobile = record.mobile
                this.form.name = record.name
                this.form.enabled = record.enabled
                this.editId = record.id
                this.form.gender = record.gender
                this.form.password = ''
            },
            // 重置密码提交
            resetOK() {
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let params = this.form
                        params.id = this.editId
                        this.$http.updatepwd(params)
                            .then(res => {
                                    this.resetvisible = false
                                    this.getList();
                                    this.$message.success('修改成功');
                                    this.resetForm()
                               
                            });
                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                });

            },
            handleCancel() {
                console.log(this.$refs.ruleForm);
                this.$refs.ruleForm.resetFields();
            },
            // 删除
            deleteRecord(record) {
                // let params = this.checkedList
                let params = [record.id]
                this.$http.deleteAdmin(params)
                    .then(res => {
                            this.getList();
                            this.$message.success('删除成功');
                       
                    });
            },
            resetForm() {
                this.form.name = ''
                this.form.account = ''
                this.form.password = ''
                this.form.mobile = ''
                // this.form.organizationId = undefined
                this.form.gender = 1
            },
            onPageChange(pageIndex, size) {
                this.pageIndex = pageIndex
                this.getList()
            },
            onSizeChange(pageIndex, size) {
                this.pageIndex = 1
                this.pageSize = size
                this.getList()
            },
            setRole(record) {
                this.rolevisible = true
                this.organizationId = record.organizationId
                this.userId = record.id;
                this.getRoleList(record.id)
            },
            close() {
                this.rolevisible = false
                this.organizationId = ""
                this.roleData = []
            },

            getRoleList(id) {
                let params = {
                    AdminId: id,
                    organizationId: this.organizationId,
                    roleTypes: 0,
                    roleGroups: [1, 2]
                };
                this.spinning = true;
                this.$http.userrole(params).then(res => {
                    this.spinning = false;
                    const { data } = res.data;
                    this.roleData = data;
                });
            },

            submitRole() {
                let params = {
                    adminId: this.userId,
                    roleIds: this.roleData.filter(f => f.hasRole).map(m => m.id)
                };
                this.$http.submituserrole(params).then(res => {
                    const { message } = res.data;
                    this.$message.success(message);
                    this.resetRole()
                });
            },
            resetRole() {
                this.roleData = [];
                this.getRoleList(this.userId)
            }
        }
    };
</script>
<style scoped>
    #Adminuser >>> .standard-table .alert {
        display: none !important;
    }

    #Adminuser >>> .searchForm {
        display: flex;

    }

    #Adminuser >>> .searchForm .fold {
        width: 35%;
        display: flex;
    }
</style>

<style lang="less" scoped>

    .search {
        margin-bottom: 54px;
    }

    .fold {
        width: calc(100% - 216px);
        display: inline-block;
    }

    .operator {
        margin-bottom: 18px;
    }

    .rolesBox {
        .ant-card {
            margin-bottom: 20px;
        }
        .btns {
            display: flex;
            justify-content: center;
        }
    }

    @media screen and (max-width: 900px) {
        .fold {
            width: 100%;
        }
    }
</style>
